import React from "react";
import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  SelectInput,
  Filter,
  DeleteButton,
  EditButton,
  ShowButton,
  Loading,
  TextInput,
} from "react-admin";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import CustomBulkActionButtons from "../Custom/CustomBulkActionsButtons";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {},
  image: {
    width: "100px",
    height: "100%",
    textAlign: "center",
  },
  checkIcon: {
    color: "green",
  },
  clearIcon: {
    color: "#f44336",
  },
  deleteIcon: {
    MuiSvgIcon: {
      root: {
        color: "#f44336",
      },
    },
  },
  chips: {
    backgroundColor: theme.palette.secondary.light,
  },
}));

const ProductFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Magic Number" source="magic_number" defaultValue="" />
    {/* <TextInput label="Discount" source="discount_percentage" defaultValue="" /> */}
    <SelectInput
      label="Active"
      source="active"
      choices={[
        { name: "Active", value: 1 },
        { name: "Inactive", value: 0 },
      ]}
      optionValue="value"
    />
  </Filter>
);

const BestSellers = (props) => {
  const classes = useStyles();
  const { permissions } = props;

  if (!permissions) return <Loading />;
  const permissionsList = permissions.split(",");

  return (
    <List
      {...props}
      exporter={false}
      filters={<ProductFilter />}
      bulkActionButtons={<CustomBulkActionButtons />}
    >
      <Datagrid rowClick={null}>
        <TextField source="magic_number" />
        <TextField source="sku" />
        <TextField source="discount_percentage" sortable={false} />
        <TextField source="kays_discount_percentage" sortable={false} />
        <FunctionField
          label="Active"
          source="active"
          render={(record) =>
            record.active ? (
              <CheckIcon className={classes.checkIcon} />
            ) : (
              <ClearIcon className={classes.clearIcon} />
            )
          }
          sortable={false}
        />
        <FunctionField
          label="Active For Kays"
          source="active_for_kays"
          render={(record) =>
            record.active_for_kays ? (
              <CheckIcon className={classes.checkIcon} />
            ) : (
              <ClearIcon className={classes.clearIcon} />
            )
          }
          sortable={false}
        />
        <ShowButton basePath="/bestsellers" />
        {permissionsList.includes("edit_dynamic-products") && <EditButton />}
        {permissionsList.includes("delete_dynamic-products") && (
          <DeleteButton className={classes.deleteIcon} undoable={false} />
        )}
      </Datagrid>
    </List>
  );
};

export default BestSellers;
